import { ITableConfig } from "@/components/table/table.model";
import { SORTING_DIR } from "@/common/models";

export const table_config: ITableConfig = {
  columns: [
    {
      name: "",
      key: "",
      sortable: false,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "3rem",
      spanMax: "3rem",
    },
    {
      name: "File Name",
      key: "file_name",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "20rem",
      spanMax: "1.5fr",
    },
    {
      name: "Space Name",
      key: "space_name",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "15rem",
      spanMax: "1fr",
    },
    {
      name: "Page Title",
      key: "page_title",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "20rem",
      spanMax: "1fr",
    },
    {
      name: "Content Type",
      key: "content_type",
      sortable: true,
      sortDir: SORTING_DIR.ASC,
      filterable: false,
      spanMin: "10rem",
      spanMax: "1fr",
    },
  ],
};
